import React from "react";
import { Spinner, Overlay2 } from "@blueprintjs/core";
import styles from "./Loader.module.scss";

/**
 * Overlay2 вместо Overlay: прежний компонент помечен устаревшим ещё в Blueprint 5,
 * а внутри у него CSSTransition без nodeRef, то есть обращение к findDOMNode.
 * В React 19 этой функции нет вовсе, и загрузчик падал бы на каждом показе.
 *
 * Overlay2 просит ссылку на единственный потомок — ему она нужна, чтобы
 * отдать её той же CSSTransition вместо поиска узла по дереву. Spinner ссылку
 * наружу не отдаёт, поэтому оборачиваем его в div: на вид это не влияет,
 * центрирует содержимое флексбокс самого оверлея.
 */
export const Loader = ({ active, usePortal }: LoaderProps) => {
  const childRef = React.useRef<HTMLDivElement>(null);

  return (
    <Overlay2
      usePortal={usePortal}
      isOpen={active}
      className={styles.align}
      backdropClassName="standard"
      /* Приведение типа, а не подгонка значения: в типах React 19 useRef(null) даёт
         RefObject<T | null>, а Blueprint 6 объявляет childRef как RefObject<HTMLElement>,
         то есть без null. Ссылка, которая начинается с null, под это объявление не
         подходит в принципе; на рантайм это не влияет — передаётся тот же объект.
         Убрать, когда Blueprint поправит объявление под типы девятнадцатой версии. */
      childRef={childRef as React.RefObject<HTMLElement>}
    >
      <div ref={childRef}>
        <Spinner intent="primary" className={styles.spinner} />
      </div>
    </Overlay2>
  );
};

export const LocalLoader = ({ active, text, zIndex }: { active: boolean; text?: string; zIndex?: number }) => {
  return active ? (
    <div className={styles.localLoader} style={{ zIndex }}>
      {text && <div className={styles.loaderText}>{text}</div>}
      <Spinner intent="primary" className={styles.spinner} />
    </div>
  ) : null;
};

interface LoaderProps {
  active: boolean;
  usePortal?: boolean;
}
